import type { Ref } from "vue"

export const checkTruncationHappy = (
    descriptionElement: Ref<HTMLElement | undefined>,
    divDescriptionElement: Ref<HTMLElement | undefined>,
    buttonElementSelect: Ref<HTMLElement | undefined>,
    maxLines: Ref<number>
) => {
    const elementText = descriptionElement.value
    const containerElement = divDescriptionElement.value
    const buttonElement = buttonElementSelect.value

    if (elementText && containerElement && buttonElement) {
        const parentStyle: CSSStyleDeclaration = getComputedStyle(containerElement)
        const paddingTop = parseFloat(parentStyle.paddingTop)
        const paddingBottom = parseFloat(parentStyle.paddingBottom)
        const heightButton: CSSStyleDeclaration = getComputedStyle(buttonElement)
        const containerHeightRemaining =
            containerElement.clientHeight -
            paddingTop -
            paddingBottom -
            parseFloat(heightButton.height) -
            parseFloat(heightButton.marginTop)
        const lineHeight = parseFloat(getComputedStyle(elementText).lineHeight)
        const calculatedMaxLines = Math.floor(containerHeightRemaining / lineHeight)
        maxLines.value = Math.max(0, calculatedMaxLines)
    }
}